const NAMESPACE = "relatedProjectsCapsule";

const KEYS = {
    createRelatedBtnLabel: "createRelatedBtnLabel",
    markRelatedBtnLabel: "markRelatedBtnLabel",
    noRelatedProjectsText: "noRelatedProjectsText",
    relatedProjectsListHeader: "relatedProjectsListHeader",
    removeRelationBtnLabel: "removeRelationBtnLabel",
    createRelatedDialogTitle: "createRelatedDialogTitle",
    createRelatedDialogCancel: "createRelatedDialogCancel",
    createRelatedDialogOk: "createRelatedDialogOk",
    createRelatedLoadingMessage: "createRelatedLoadingMessage",
    markRelatedDialogTitle: "markRelatedDialogTitle",
    markRelatedDialogCancel: "markRelatedDialogCancel",
    markRelatedDialogOk: "markRelatedDialogOk",
    markRelatedLoadingMessage: "markRelatedLoadingMessage",
    removeRelationDialogTitle: "removeRelationDialogTitle",
    removeRelationDialogMessage: "removeRelationDialogMessage",
    removeRelationLoadingMessage: "removeRelationLoadingMessage",
    unsubmittedProjectName: "unsubmittedProjectName"
};

const MESSAGES = {
    [KEYS.createRelatedBtnLabel]: {
        value: "Create Related Project",
        comment: "Label for the button that allows users to create a new related project"
    },
    [KEYS.markRelatedBtnLabel]: {
        value: "Mark Project as Related",
        comment: "Label for the button that allows users to mark this project as related to an existing project"
    },
    [KEYS.noRelatedProjectsText]: {
        value: "No related projects found.",
        comment: "Text that indicates that there were no projects found which are related to the current project"
    },
    [KEYS.relatedProjectsListHeader]: {
        value: "Related Projects:",
        comment: "Header for the list of projects that are related to this one"
    },
    [KEYS.removeRelationBtnLabel]: {
        value: "Remove",
        comment: "Label for the button that allows the user to no longer consider a project related to this one"
    },
    [KEYS.createRelatedDialogTitle]: {
        value: "Create Related Project",
        comment: "Title of the dialog where the user can create a new related project"
    },
    [KEYS.createRelatedDialogCancel]: {
        value: "Cancel",
        comment: "Cancel button label in the create related project dialog"
    },
    [KEYS.createRelatedDialogOk]: { value: "OK", comment: "OK button label in the create related project dialog" },
    [KEYS.createRelatedLoadingMessage]: {
        value: "Creating related project...",
        comment: "Loading message that displays while a related project is being created"
    },
    [KEYS.markRelatedDialogTitle]: {
        value: "Mark Project as Related",
        comment: "Title for the dialog where the user can mark an existing project as related to this one"
    },
    [KEYS.markRelatedDialogCancel]: { value: "Cancel", comment: "Cancel button label in the mark related dialog" },
    [KEYS.markRelatedDialogOk]: { value: "OK", comment: "OK button label in the mark related dialog" },
    [KEYS.markRelatedLoadingMessage]: {
        value: "Marking project as related...",
        comment: "Loading message that displays while marking a project as related to this one"
    },
    [KEYS.removeRelationDialogTitle]: {
        value: "Confirm Removal",
        comment: "Title for the dialog where the user can mark a project as no longer related to this one"
    },
    [KEYS.removeRelationDialogMessage]: {
        value: "This will delete the relationship marker to the following project: {projectNumber}. Are you sure?",
        comment: "Confirmation message in the dialog where a user can mark a project as no longer related to this one"
    },
    [KEYS.removeRelationLoadingMessage]: {
        value: "Removing project relationship...",
        comment: "Loading message that displays while a project relationship is being removed"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
